<template>
  <div id="address-search" class="active">
    <div class="address-search__inner">
      <h1>마케팅 수신동의</h1>

      <div class="my-4 px-4">
        <br />
        <b>1. 광고성 정보의 이용목적</b><br />
        장례박사가 제공하는 이용자 맞춤형광고 서비스 및 신규프로그램 등의 광고성
        정보를 전자우편이나 서신우편, 문자(SMS 또는 카카오 알림톡), 푸시, 전화
        등을 통해 이용자에게 제공합니다.<br />

        - 마케팅 수신 동의는 거부하실 수 있으며 동의 이후에라도 고객의 의사에
        따라 동의를 철회할 수 있습니다. 동의를 거부하시더라도 장례박사가
        제공하는 서비스의 이용에 제한이 되지 않습니다. 단, 신규 무료 프로그램 및
        이용자 맞춤형 광고서비스 등의 마케팅 정보 안내 서비스가 제한됩니다.<br />
        <br />
        <b>2.미동의 시 불이익 사항</b><br />
        개인정보보호법 제22조 제5항에 의해 선택정보 사항에 대해서는 동의
        거부하시더라도 서비스 이용에 제한되지 않습니다. 단 신규 프로그램 및
        이용자 맞춤형 광고 등의 마케팅 정보 안내 서비스가 제한됩니다.
        <div class="agree mt-16">
          <v-checkbox
            v-model="agreeFlag"
            label="동의합니다"
            color="brown"
          ></v-checkbox>
          <!-- <input type="checkbox" name="obituaryleader" v-model="agreeFlag" />
          <span class="ml-2" @click="agreeFlag = !agreeFlag">
            동의합니다
          </span> -->
        </div>
        <button
          style=" width: 100%;
  height: 48px;

  margin-top: 36px;

  font-weight: 700;
  font-size: var(--default);
  font-family: var(--noto3);
  color: var(--white-font);

  background: var(--main-color);
  border-radius: 8px;"
          class="btn_join mt-4"
          @click="method(agreeFlag)"
        >
          확인
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddressSearch",
  props: ["method", "marketingAgree"],
  data() {
    return {
      address: "",
      searchType: "only",
      agreeFlag: false
    };
  },
  mounted() {
    this.agreeFlag = this.marketingAgree;
  },
  computed: {},
  methods: {
    close() {
      $("#address-search").removeClass("active");
      this.$store.commit("END_DEEMED");
    }
  }
};
</script>
